var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var open = ref.open
              return [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "text--secondary", attrs: { cols: "12" } },
                      [
                        _c(
                          "v-fade-transition",
                          { attrs: { "leave-absolute": "" } },
                          [
                            open
                              ? _c(
                                  "v-row",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(" Totals Amounts Discounted "),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { dense: "" },
                                  },
                                  [
                                    _c("h4", { attrs: { "pb-2": "" } }, [
                                      _vm._v(" Discount: "),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        " " + _vm._s(_vm.discount || 0) + " % "
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("h4", { attrs: { "pb-2": "" } }, [
                                      _vm._v(" Proposal Amounts Discounted: "),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.FormatMoney(
                                              _vm.offerAmountsDiscounted || 0
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("pga-number-field", {
                    attrs: {
                      label: "Discount",
                      prefix: "%",
                      dense: "",
                      readonly: "",
                    },
                    model: {
                      value: _vm.discount,
                      callback: function ($$v) {
                        _vm.discount = $$v
                      },
                      expression: "discount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("pga-currency-field", {
                    attrs: {
                      label: "Proposal Amounts Discounted",
                      dense: "",
                      readonly: "",
                    },
                    model: {
                      value: _vm.offerAmountsDiscounted,
                      callback: function ($$v) {
                        _vm.offerAmountsDiscounted = $$v
                      },
                      expression: "offerAmountsDiscounted",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("pga-currency-field", {
                    attrs: {
                      label: "Expected Costs Discounted",
                      dense: "",
                      readonly: "",
                    },
                    model: {
                      value: _vm.expectedCostsDiscounted,
                      callback: function ($$v) {
                        _vm.expectedCostsDiscounted = $$v
                      },
                      expression: "expectedCostsDiscounted",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("pga-currency-field", {
                    attrs: {
                      label: "Expected Margins Discounted",
                      dense: "",
                      readonly: "",
                    },
                    model: {
                      value: _vm.expectedMarginsDiscounted,
                      callback: function ($$v) {
                        _vm.expectedMarginsDiscounted = $$v
                      },
                      expression: "expectedMarginsDiscounted",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("pga-text-field", {
                    attrs: {
                      label: "Expected Margins Discounted %",
                      prefix: "%",
                      dense: "",
                      readonly: "",
                    },
                    model: {
                      value: _vm.expectedMarginsDiscountedPerc,
                      callback: function ($$v) {
                        _vm.expectedMarginsDiscountedPerc = $$v
                      },
                      expression: "expectedMarginsDiscountedPerc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }